import { take, call, put } from 'redux-saga/effects';
import { projects as actionTypes } from '$constants/action-types';
import * as actions from '$actions/projects';
import { alert } from './root';
import axios from 'axios';

const fetchAll = params => axios.get(`/projects`, { params });
const fetch = params => axios.get(`/projects/${params.id}`, { params });
const fetchMap = id => axios.get(`/projects/${id}/activity_map`);
const createReport = (type, q) => axios.post(`/projects/reports`, { report: { type }, q });

function* watchFetchAll() {
  while(true) {
    const action = yield take(actionTypes.FETCH_ALL);
    yield put(actions.fetchAllRequest());
    const { data } = yield call(fetchAll, action.params);
    const hasMore = data.meta.total_count / (25 * action.params.page) >= 1;
    yield put(actions.fetchAllSuccess(data.data, hasMore));
  }
}

function* wacthFetch() {
  while(true) {
    const action = yield take(actionTypes.FETCH);
    yield put(actions.fetchRequest());
    const { data } = yield call(fetch, action.params);
    const mapResponse = yield call(fetchMap, action.params.id);
    data.data.activity_map = mapResponse.data.data;
    yield put(actions.fetchSuccess(data.data));
  }
}

function* watchCreateReport() {
  while(true) {
    const action = yield take(actionTypes.CREATE_REPORT);
    const { data } = yield call(createReport, action.fileType, action.filters);
    const alertMessage = `We will send you an e-mail with a link that you can
      download the report in 5 minutes.`;

    yield alert('Report Queued', alertMessage);
  }
}

export const watchers = [
  watchFetchAll,
  wacthFetch,
  watchCreateReport
];



// WEBPACK FOOTER //
// ./src/sagas/projects.js